import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const ExpandMoreIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path fill="currentColor" d="m19.65 9.759-7 6-.65.558-.65-.558-7-6 1.3-1.518L12 13.684l6.35-5.443z" />
  </BaseIcon>
)
